import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy, TemplateRef, HostListener, AfterContentChecked } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DragulaService } from 'ng2-dragula';
import * as moment from 'moment';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-prix-negocies',
  templateUrl: './prix-negocies.component.html',
  styleUrls: ['./prix-negocies.component.css']
})
export class PrixNegociesComponent implements OnInit, OnDestroy, AfterContentChecked {
  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Input() depuisDevis: Boolean;
  @Input() depuisAutre: Boolean;
  @Input() isDepuisMenuEnHaut: Boolean;
  @Input() depuisFicheClient: Boolean;
  @Output() show = new EventEmitter<any>();
  @Output() insertDevis = new EventEmitter<any>();

  listPrixNegocier = [];
  selected = [];
  listChecked: any[] = []
  dataArticle = [];
  dynamicFiltre: any[] = [];
  selectedFilter: any = {}
  listChantier = [{ id: 0, libelleObjetEntite: 'Tous' }];
  listeAgence = [{ id: 0, libelleObjetEntite: 'Toutes' }];
  listeZone = [{ id: 0, libelleObjetEntite: 'Toutes' }];
  isEmpty: Boolean = true;
  renderTable: Boolean = true;
  isHisto: Boolean = false;
  hideRemorque: Boolean = false;
  isFamille2: Boolean = false;
  isPNArt: Boolean = false;
  isEdit: Boolean = false;
  isReconduire: Boolean = false;
  isClick: Boolean = false;
  default = 0;
  societe;
  classPresta: String = 'detailfact ';
  focusIndex = 0;
  selectedRow: any = {};
  listFamilleArt = [];
  listExutoire: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  listTypeContenant: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  artContenu: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  listMateriel: any = [{ id: 0, libelle: 'Aucun', libelleObjetEntite: 'Aucun' }];
  dataOperation: any = [];
  error = '';
  listTarifQte = [];
  listPrixReconduire = [];
  listDerPrixNeg = [];
  dateReconduction = '';
  familleImprimable = '8';
  familleXls = '8';
  listCombo = [
    { id: '8', libelleObjetEntite: 'Toutes' },
    { id: '1', libelleObjetEntite: 'Déchet' },
    { id: '3', libelleObjetEntite: 'Matière' },
    { id: '2', libelleObjetEntite: 'Prestation' },
  ];
  isDroitModifierPrixNego = false;
  articleHover: any = {};
  offset: any = {};
  offsetHisto: any = {};
  resizeCol: any = {};
  checkedall: Boolean = false;
  nepasModifierficheClient: Boolean = false;
  dateFinSelected

  columnsHisto = [
    {
      name: "Article.code", prop: "article.code", width: 124
    },
    { name: "Art Libelle", prop: "artLibelle", width: 150 },
    {
      name: "codeBanque", prop: "article.unite", width: 70
    },
    {
      name: "tarif", prop: "tarif", width: 90
    },
    {
      name: "dateDebut", prop: "modelDebut", width: 110
    }, {
      name: "dateFin", prop: "modelFin", width: 110
    },
    {
      name: "Chantier Libelle", prop: "chantierLibelle", width: 150
    },
    {
      name: "Exutoire Libelle", prop: "exutoireLibelle", width: 150
    },
    {
      name: "Commentaire", prop: "commentaire", width: 110
    },
    {
      name: "Article Contenu Libelle", prop: "articleContenuLibelle", width: 180
    },
    {
      name: "Agence Libelle", prop: "agenceLibelle", width: 100
    },
    {
      name: "", width: 150
    },
    {
      name: "Zone Libelle", prop: "zoneLibelle", width: 100
    },
    {
      name: "Camion Libelle", prop: "camionLibelle", width: 100
    }
  ];

  columns = [
    { prop: '', name: '', width: 40 },
    {
      name: "Article.code", prop: "article.code", width: 124
    },
    { name: "Art Libelle", prop: "artLibelle", width: 150 },
    {
      name: "codeBanque", prop: "article.unite", width: 70
    },
    {
      name: "tarif", prop: "tarif", width: 90
    },
    {
      name: "dateDebut", prop: "modelDebut", width: 110
    }, {
      name: "dateFin", prop: "modelFin", width: 110
    },
    {

      name: "Chantier Libelle", prop: "chantierLibelle", width: 150
    },
    {
      name: "Exutoire Libelle", prop: "exutoireLibelle", width: 150
    },
    {
      name: "Commentaire", prop: "commentaire", width: 110
    },
    {
      name: "Article Contenu Libelle", prop: "articleContenuLibelle", width: 180
    },
    {
      name: "Agence Libelle", prop: "agenceLibelle", width: 100
    },
    {
      name: "", width: 150
    },
    {
      name: "Zone Libelle", prop: "zoneLibelle", width: 100
    },
    {
      name: "Camion Libelle", prop: "camionLibelle", width: 100
    }
  ];

  private latestWidth: number;
  @ViewChild('msg') msg;
  @ViewChild('xls') xls;
  @ViewChild('loading') loading;
  @ViewChild('choixDateFin') choixDateFin;
  @ViewChild('myTable') table: any;

  loadingIndicator: boolean;
  modalRef: BsModalRef;
  isScroll = false;
  modelDateFinSel
  public status: { isopen: boolean, child: boolean } = { isopen: false, child: false };
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if ($(window).width() < 1700) {
      this.isScroll = true
    } else {
      this.isScroll = true
    }
  }

  listFiltreAgence: any[] = [];
  listPrixNegocierOriginal: any[] = []
  listFiltreChantier: any[] = []


  constructor(public common: CommonService, private modalService: BsModalService, private dragulaService: DragulaService) {
    this.societe = this.common.local.getObject('paramSociete') || {};
    /*
    dragulaService.createGroup('PERSON', {
      removeOnSpill: true,
      copyItem: (item) => {
        return item;
      },
      copy: (el, source) => {
        return source.id === 'left';
      },
      accepts: (el, target, source, sibling) => {
        // To avoid dragging from right to left container
        return target.id !== 'left';
      }
    });
    */

    this.dragulaService.createGroup('PERSON', {
      removeOnSpill: false // ne rien supprimer automatiquement
    });

  }

  ngOnInit() {
    if ($(window).width() < 1700) {
      this.isScroll = true
    } else {
      this.isScroll = true
    }
    const userDetail = this.common.local.getObject('userDetail');
    this.isDroitModifierPrixNego = ((userDetail.clefDroit & 0x00020000) !== 0) ? true : false; // DROIT_PRIXNEGO
    this.depuisDevis = this.depuisDevis || false;
    this.isDepuisMenuEnHaut = this.isDepuisMenuEnHaut || false;
    console.log('isDroitModifierPrixNego=' + this.isDroitModifierPrixNego);
    console.log('depuisDevis=' + this.depuisDevis);
    console.log('isDepuisMenuEnHaut=' + this.isDepuisMenuEnHaut);
    this.common.ficheClientPrixNegocies = this.common.ficheClientPrixNegocies || {};
    if (this.isDepuisMenuEnHaut) {
      this.columns = this.common.ficheClientPrixNegocies['columns'] || this.columns;
      this.columnsHisto = this.common.ficheClientPrixNegocies['columnsHisto'] || this.columnsHisto;
      this.offset = this.common.ficheClientPrixNegocies['offset'] || this.offset;
      this.offsetHisto = this.common.ficheClientPrixNegocies['offsetHisto'] || this.offsetHisto;
    }


    this.nepasModifierficheClient = this.depuisFicheClient && !this.add && !this.common.isModifClient ? true : false;
    console.log(this.add, this.edit, this.depuisFicheClient, this.nepasModifierficheClient)
    this.isClick = false;
    this.getListPrixNego().then(data => {
      this.isEmpty = false;
      this.parseDate();
      this.getListeAgence();
      this.searchTypecontenant();
      this.getFamilleArt();
      this.getListeZone();
    });

    const listOperation1 = (this.common.getType('listOperationNonSupp') || []);
    let listOperation2 = (this.common.getType('listOperationSupp') || []);
    listOperation2 = listOperation2.filter(elt => {
      const libelle = (elt.libelle || '').toLowerCase();
      return libelle !== 'autres';
    });
    let listOperation3 = (this.common.getType('listOperationSuppBennePlace') || []);
    listOperation3 = listOperation3.filter(elt => {
      const libelle = (elt.libelle || '').toLowerCase();
      return libelle !== 'autres';
    });
    const dataOperation = [...listOperation1, ...listOperation2, ...listOperation3];

    const flags = [], output = [], l = dataOperation.length;
    for (let i = 0; i < l; i++) {
      if (flags[dataOperation[i].id]) {
        continue;
      }
      flags[dataOperation[i].id] = true;
      this.dataOperation.push(dataOperation[i]);
    }
    this.dataOperation.forEach(elt => {
      if (!elt.id) {
        elt.id = 0;
      }
      elt.libelleObjetEntite = elt.libelle;
    });
  }

  ngOnDestroy() {
    this.dragulaService.destroy('PERSON');
    if (this.isDepuisMenuEnHaut) {
      this.common.ficheClientPrixNegocies['columns'] = this.columns;
      this.common.ficheClientPrixNegocies['columnsHisto'] = this.columnsHisto;
    }
  }

  ngAfterContentChecked() {
    this.actualiseWidth();
  }

  getpays(id) {
    let elt;
    this.common.getType('typePays').forEach(elem => {
      if (elem.id === id) {
        elt = elem;
      }
    });
    return elt;
  }

  parseDate() {
    this.listPrixNegocier.forEach(elt => {
      elt.dateDebut = moment(elt.dateDebut, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
      elt.dateFin = elt.dateFin ? moment(elt.dateFin, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : '31/12/9999';
      elt.modelDebut = this.common.parseDate(elt.dateDebut);
      elt.modelFin = this.common.parseDate(elt.dateFin);
    });
  }

  hide() {
    this.show.emit();
  }

  editRow(row) {
    this.isEdit = true;
    this.selectedRow = Object.assign({}, row);
    this.selectedRow.isFamille = false;
    this.selectedRow.checkOperation = false;
    if (this.selectedRow.operationBenne) {
      this.selectedRow.checkOperation = (this.selectedRow.operationBenne && this.selectedRow.operationBenne.libelle) ? true : false;
    }
    if (this.selectedRow.typeArticle) {
      this.selectedRow.isFamille = this.selectedRow.typeArticle.id > 0 ? true : false;
    }

    if (this.selectedRow.article) {
      this.checkFamilleArt(this.selectedRow.article.id);
    }
  }

  showHisto() {
    const ctrl = this;
    this.isHisto = !this.isHisto;
    this.renderTable = false;
    setTimeout(() => {
      ctrl.renderTable = true;
    }, 100);
    this.listPrixNegocier = [];
    if (this.isHisto) {
      this.getListPrixNegoHisto();
    } else {
      this.getListPrixNego();
    }
  }

  getListPrixNego() {
    this.detail['nomclass'] = 'Client';
    this.loadingIndicator = true;
    this.listPrixNegocier = [];
    const param = {
      'servlet': 'DBGetListPrixNego',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [
        ['DBGetListPrixNego'],
        {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        '' + this.common.user[2],
        {
          'typeParam': 'boolean',
          'valeur': false
        },
        {
          'typeParam': 'int',
          'valeur': 0
        }
      ]
    };

    return this.common.post('', { param: param }, true).then(datas => {
      $('#empty').trigger('click');
      this.listPrixNegocier = datas.data || [];
      this.listPrixNegocier.forEach(row => {
        this.getLibelleContenant(row.contenant)
        row.artLibelle = '';
        if (row.article && row.article.id) {
          row.artLibelle = row.article.libelle || '';
        } else {
          if (row.operationBenne) {
            row.artLibelle = row.operationBenne.libelle || '';
          }
        }
        row.agenceLibelle = row.agence ? (row.agence.libelle || row.agence.nom || row.agence.libelleObjetEntite) : 'Toutes';
        // change libelle si famille article
        if (row.typeArticle) {
          row.isFamille = row.typeArticle.id > 0 ? true : false;
        }

        if (row.isFamille) {
          row.articleContenuLibelle = row.typeArticle && row.typeArticle.id ? row.typeArticle.libelle : 'Tous';
        } else {
          row.articleContenuLibelle = row.articleContenantContenu ?
            `${row.articleContenantContenu.code || ''}/${row.articleContenantContenu.libelle || ''}` : 'Tous';
        }
        // change libelle si famille article
        row.exutoireLibelle = row.exutoire ? row.exutoire.nom : 'Tous';
        row.zoneLibelle = row.zoneClible ? row.zoneClible.libelle : 'Tous';
        row.camionLibelle = row.camion ? row.camion.immatriculation : 'Aucun';
        row.chantierLibelle = row.chantier ? row.chantier.numChantier : 'Tous';
        row.chantierRespVille = row.chantier ? `${row.chantier.responsable || ''}/${row.chantier.ville || ''}` : '';
      });

      this.listPrixNegocierOriginal = [...this.listPrixNegocier];
      this.getListFiltrePrixNego()

      this.parseDate();
      this.updateAfficheScroll();
      this.filterList();
      this.loadingIndicator = false;
      return datas.data;
    });
  }

  getListPrixNegoHisto() {
    this.detail['nomclass'] = 'Client';
    this.loadingIndicator = true;
    this.listPrixNegocier = [];
    const param = {
      'servlet': 'DBGetListPrixNegociesHisto',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.societe['prixNegoParSite'] ? this.common.user[2] : 0
        },
        'IS_AJOUT_DONNEES_CONTRAT': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'CLEF_CONTRAT_EXCLU': {
          'typeParam': 'int',
          'valeur': 0
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      this.listPrixNegocier = datas.data || [];
      this.listPrixNegocier.forEach(row => {
        this.getLibelleContenant(row.contenant)
        row.artLibelle = '';
        if (row.article && row.article.id) {
          row.artLibelle = row.article.libelle || '';
        } else {
          if (row.operationBenne) {
            row.artLibelle = row.operationBenne.libelle || '';
          }
        }
        row.agenceLibelle = row.agence ? (row.agence.libelle || row.agence.nom || row.agence.libelleObjetEntite) : 'Toutes';
        row.articleContenuLibelle = row.articleContenantContenu ?
          `${row.articleContenantContenu.code || ''}/${row.articleContenantContenu.libelle || ''}` : 'Tous';
        row.exutoireLibelle = row.exutoire ? row.exutoire.nom : 'Tous';
        row.zoneLibelle = row.zoneClible ? row.zoneClible.libelle : 'Tous';
        row.camionLibelle = row.camion ? row.camion.immatriculation : 'Aucun';
        row.chantierLibelle = row.chantier ? row.chantier.numChantier : 'Tous';
        row.chantierRespVille = row.chantier ? `${row.chantier.responsable || ''}/${row.chantier.ville || ''}` : '';
      });
      this.parseDate();
      this.updateAfficheScroll();
      this.listPrixNegocierOriginal = [...this.listPrixNegocier];
      this.getListFiltrePrixNegoHisto();
      this.filterList();
      this.loadingIndicator = false;
      return datas.data;
    });
  }

  recalcule() {
    this.actualiseWidth();
  }

  actualiseWidth() {
    if (this.table && this.table.element.clientWidth !== this.latestWidth) {
      this.latestWidth = this.table.element.clientWidth;
      this.table.recalculate();
    }
  }

  updateAfficheScroll() {
    if (!this.isHisto) {

      console.log(this.offset)
      if (this.offset && this.offset.offsetY) {
        setTimeout(() => { $('datatable-body').scrollTop(this.offset.offsetY || 0); }, 100);
      }

      if (this.offset && this.offset.offsetX) {
        setTimeout(() => { $('datatable-body').scrollLeft(this.offset.offsetX || 0); }, 100);
      }
    } else {
      console.log(this.offsetHisto)
      if (this.offsetHisto && this.offsetHisto.offsetY) {
        setTimeout(() => { $('datatable-body').scrollTop(this.offsetHisto.offsetY || 0); }, 100);
      }

      if (this.offsetHisto && this.offsetHisto.offsetX) {
        setTimeout(() => { $('datatable-body').scrollLeft(this.offsetHisto.offsetX || 0); }, 100);
      }
    }
    setTimeout(() => { this.recalcule() }, 100);
  }

  selectRow(row) {
    this.focusIndex = this.listPrixNegocier.indexOf(row);
    this.selected = [row];
  }

  addLigne() {
    let dateDebut, dateFin;
    if (this.societe['datePNDefaut']) {
      dateDebut = this.common.parseDate(moment().startOf('year').format('DD/MM/YYYY'));
      dateFin = this.common.parseDate(moment().endOf('year').format('DD/MM/YYYY'));
      this.selectedRow['modelFin'] = dateFin
      this.selectedRow['modelDebut'] = dateDebut
    }

  }

  searchArticle(event) {
    this.dataArticle = [];
    const param = 2;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.dataArticle = datas.data;
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  setValue(event, row?) {
    this.checkFamilleArt(event.id);
  }

  checkFamilleArt(id) {
    const param = {
      'servlet': 'DBCheckFamilleArticle',
      'module': 'Recylog',
      'type': 'objet',
      'compression': 'false',
      'data': {
        'typeParam': 'string',
        'valeur': '' + (id || 0)
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      const data = datas.data;
      this.isFamille2 = data.length && data[0] === 2 ? true : false;
      this.selectedRow['unite'] = data[1];
      return datas.data;
    });
  }

  searchChantier(event) {
    this.listChantier = [{ id: 0, libelleObjetEntite: 'Tous' }];
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {

        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'CRITERE': event || ''
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listChantier = [...this.listChantier, ...datas.data];
      }
    });
  }

  getListeAgence() {
    const param = {
      'servlet': 'DBAgenceGet',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id'] || 0
        },
        'CRITERE': ''
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listeAgence = [...this.listeAgence, ...datas.data];
      }
    });
  }

  focus(event) {
    const input = event.target;
    const originalValue = $(input).val();
    $(input).val('');
    $(input).blur().focus().val(originalValue);
  }

  calculMontant(row) {
    if (row.qte && row.tarif) {
      row.prixHT = row.qte * row.tarif;
    } else {
      row.prixHT = 0;
    }
  }

  getFamilleArt() {
    const param = {
      'servlet': 'DBGetTypeArticle',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['']
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas) && datas.data != null) {
        this.listFamilleArt = datas.data;
        this.listFamilleArt.unshift({ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' });
        this.listFamilleArt.forEach(elt => elt.libelleObjetEntite = elt.libelle);
      }
    });
  }

  searchArticleContenu(event) {
    this.artContenu = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
    const param = 3;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.artContenu = [...this.artContenu, ...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  searchTypecontenant() {
    this.listTypeContenant = [{ id: 0, libelleObjetEntite: 'Tous' }];
    this.common.getType('listetypeContenant').forEach(elt => {
      elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? elt.cubage.cubage + ' ' : '') +
        (elt.uniteCont ? elt.uniteCont.libelle : '');
      this.listTypeContenant.push(elt);
    });
  }

  searchExutoire(event) {
    const param = 6;
    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        const l = [{ id: 0, libelleObjetEntite: 'Tous' }];
        l.push(...datas.data);
        this.listExutoire = l;
      }
    });
  }

  searchListCamion(critere) {
    const data = {
      'TOUS_CAMIONS': {
        'typeParam': 'boolean',
        'valeur': true
      },
      'CAMIONS_CEDES': {
        'typeParam': 'boolean',
        'valeur': false
      },
      'IS_FILTRE_RECEPTION_CHANTIER': {
        'typeParam': 'boolean',
        'valeur': false
      },
      'IS_RECEPTION_CHANTIER': {
        'typeParam': 'boolean',
        'valeur': false
      },
      'AU_GARAGE': {
        'typeParam': 'boolean',
        'valeur': false
      },
      'TO_STRING_AVEC_NUM_PARC': {
        'typeParam': 'boolean',
        'valeur': false
      },
      'VISIBLE_ECODECHET': {
        'typeParam': 'boolean',
        'valeur': false
      },
      'IS_CAMION_MULTIBENNE_ECOLOC': {
        'typeParam': 'boolean',
        'valeur': false
      },

      'GET_ONLY_SITE_USER': {
        'typeParam': 'boolean',
        'valeur': false
      },
      'CRITERE': critere || ''
    };

    return this.common.post('', {
      param: {
        'servlet': 'DBGetListCamion',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': data,
      }
    }).then(datas => {
      datas.data.forEach(elt => {
        const l = (elt.numParc ? elt.numParc + ' / ' : '') + (elt.immatriculation ? elt.immatriculation : '');
        elt.libelleObjetEntite = l;
      });

      this.listMateriel = datas.data || [];
      return datas;
    }).catch(error => {
      throw error;
    });
  }

  changeOperation(row) {
    row.remorque = false;
    if (row.checkOperation) {
      row.article = { id: 0, libelle: '', libelleObjetEntite: '' };
      row.artContenu = this.artContenu[0];
      row.contenant = this.listTypeContenant[0];
      this.hideRemorque = true;
    } else {
      row.article = { id: 0, libelle: '', libelleObjetEntite: '' };
      this.isFamille2 = true;
      row.artContenu = this.artContenu[0];
      row.contenant = this.listTypeContenant[0];
      row.operationBenne = { id: 0 };
      this.hideRemorque = false;
    }
  }

  changeFamilleArt(row) {
    row.artContenu = this.artContenu[0];
    if (!row.famille) {
      row.typeArticle = this.artContenu[0];
    }
    this.isPNArt = false;
  }

  changeContenu(row) {
    row.isFamille = false;
    row.typeArticle = { id: 0, libelle: '' };
    if (!row.id && (row.artContenu && row.artContenu['id'])) {
      this.isPNArt = true;
    } else {
      this.isPNArt = false;
    }
  }

  getListeZone() {
    this.common.post('', {
      param: {
        'servlet': 'DBGetListZone',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {}
      }
    }).then(datas => {
      const tab = datas.data;
      const liste = [];
      for (const i in tab[0]) {
        if (tab[1].length && tab[0].length) {
          liste.push({ id: parseInt(tab[1][i], 10), libelle: tab[0][i], libelleObjetEntite: tab[0][i] });
        }
      }

      this.listeZone = [...this.listeZone, ...liste];

    }).catch(error => console.log(error));
  }

  valideNegoBeforeSave() {
    this.selectedRow = this.selectedRow || {};
    this.selectedRow['nomclass'] = 'PrixNegocies';
    if (!this.selectedRow['dateFin']) {
      this.selectedRow['dateFin'] = moment(this.selectedRow.modelFin).format('DD/MM/YYYY')
    }
    if (!this.selectedRow['dateDebut']) {
      this.selectedRow['dateDebut'] = moment(this.selectedRow.modelDebut).format('DD/MM/YYYY')
    }
    const client = Object.assign({}, this.detail)
    client['nomclass'] = 'Client';
    client['listPrixNego'] = this.listPrixNegocier || [];
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 7
        },
        'PRIX_NEGO': this.selectedRow,
        'CLIENT': client,
        'SITE': '' + this.common.user[2],
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      if (this.common.verifySession(datas)) {
        // console.log(datas);
        if (datas.message) {
          this.error = datas.message;
          this.common.openModal(this.modalService, this.msg);
        } else {
          if (datas.data !== '') {
            this.error = datas.data;
            this.common.openModal(this.modalService, this.msg);
          } else {
            this.saveModif();
          }
        }
      }
    });
  }

  saveModif(row?) {
    this.selectedRow = row ? row : this.selectedRow;
    this.selectedRow['nomclass'] = 'PrixNegocies';
    this.selectedRow['modelDebut'] = this.selectedRow.modelDebut
    this.selectedRow['modelFin'] = this.selectedRow.modelFin
    if (row) {
      this.selectedRow['dateDebut'] = this.selectedRow.modelDebut
      this.selectedRow['dateFin'] = this.selectedRow.modelFin
    } else {
      this.selectedRow['dateDebut'] = moment(this.selectedRow.modelDebut).format('DD/MM/YYYY')
      this.selectedRow['dateFin'] = moment(this.selectedRow.modelFin).format('DD/MM/YYYY')
    }
    this.isEdit = false;
    this.selectedRow.checkOperation = (this.selectedRow.operationBenne && this.selectedRow.operationBenne.libelle) ? true : false;
    if (!this.selectedRow.checkOperation) {
      this.selectedRow.operationBenne = {
        id: -1
      };
    }
    const param = {
      'servlet': 'DBMAJPrixNegocie',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [['DBMAJPrixNegocie'], this.selectedRow, this.detail, '' + this.common.user[2]]
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      if (this.common.verifySession(datas)) {
        const etat = this.selectedRow.id ? false : true;
        if (!row) {
          this.isEmpty = false;
          if (datas.message) {
            this.error = datas.message;
            this.common.openModal(this.modalService, this.msg);
          } else {
            this.common.createLog('135', datas.data['1'], etat);
            this.selectedRow = {};
            this.getListPrixNego();
          }
        } else {
          return this.common.createLog('135', datas.data['1'], etat);
        }
      }
    });
  }

  getLibelleContenant(elt) {
    if (elt) {
      if (elt.famille) {
        elt.famille.libelle = (elt.famille.libelle || '').replace('mcube', 'm³')
      }
      elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? elt.cubage.cubage + ' ' : '') +
        (elt.uniteCont && elt.uniteCont.libelle ? elt.uniteCont.libelle : '');

      //console.log('elt.libelleObjetEntite='+elt.libelleObjetEntite);
    }
  }

  majRetroTarif() {
    const ctrl = this;
    this.common.closeModal();
    this.openModalEncours(this.loading);

    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBPrixNegoRetro',
      'module': 'Recylog',
      'type': 'objet',
      'compression': 'false',
      'data': this.detail
    };

    return this.common.post('', { param: param }).then(datas => {
      this.closeModal();
      if (this.common.verifySession(datas)) {
        if (datas.message) {
          this.error = datas.message;
          this.common.openModal(this.modalService, this.msg);
        }
      }
    }).catch(error => {
      this.closeModal();
    });
  }

  openModalEncours(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      animated: true,
      keyboard: true,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'confirmModal'
    });
  }

  closeModal() {
    const ctrl = this;
    if (ctrl.modalRef) {
      const timer = setInterval(function () {
        if ($(".loadingpopup").is(":visible")) {
          ctrl.modalRef.hide();
        } else {
          clearInterval(timer);
        }
      }, 300);
    }
  }

  showTarifQte() {
    this.selectedRow['tarif'] = 0;
    this.selectedRow['article'] = this.selectedRow['article'] || {};
    this.listTarifQte = this.selectedRow['article'].listTarifQte || [];
  }

  hideModal() {
    this.listTarifQte = [];
    this.common.closeModal();
  }

  saveTarifQte(event) {
    this.selectedRow['article'] = this.selectedRow['article'] || {};
    this.selectedRow['article'].isQteSupp = event.isQteSupp;
    this.selectedRow['article'].listTarifQte = event.listTarifQte;
    this.selectedRow['article'].listTarifQte.forEach(elt => {
      const qte = elt.quantite + '';
      const tarif = elt.tarif + '';
      elt.quantite = qte.replace(/,/g, '.');
      elt.tarif = tarif.replace(/,/g, '.');
    });
    // console.log(this.selectedRow['article']);
  }

  getListPrixDerNeg() {
    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBGetListDernierPrixNego',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [['DBGetListDernierPrixNego'], this.detail, '' + this.common.user[2]]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas) && datas.data != null) {
        this.listDerPrixNeg = datas.data || [];
        this.listDerPrixNeg.forEach(elt => {
          const date = this.common.parseDate(moment(elt.dateFin, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
          elt.time = new Date(date).getTime();
        });
        // console.log(this.listDerPrixNeg, this.getMinDate(this.listDerPrixNeg));
        this.isReconduire = true;
        this.revertReconduction();
      }
    });
  }

  saveReconduction() {
    // this.isReconduire = false;
    const prom = [];
    const min = this.getMinDate(this.listPrixReconduire);
    this.dateReconduction = this.dateReconduction !== '' ? this.dateReconduction : moment().format('DD/MM/YYYY');
    let dateFin, date1;
    if (!this.listPrixReconduire.length) {
      this.error = `Aucun prix à reconduire`;
      this.common.openModal(this.modalService, this.msg);
      return false;
    }
    date1 = min[0].dateFin;
    this.listPrixReconduire.forEach(elt => {
      const dFin = this.common.parseDate(moment(elt.dateFin, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
      const date = new Date(dFin).getTime();
      const d = this.common.parseDate(moment(this.dateReconduction, 'DD/MM/YYYY').format('DD/MM/YYYY'));
      const dateReconduite = new Date(d).getTime();
      if (dateReconduite <= date) {
        dateFin = true;
      }
    });

    if (dateFin) {
      this.error = `La date de reconduction doit être supérieure au : ${date1}`;
      this.common.openModal(this.modalService, this.msg);
      return;
    } else {
      this.listPrixReconduire.forEach(elt => {
        elt.dateDebut = moment(elt.dateFin, 'DD/MM/YYYY').add(1, 'day').format('DD/MM/YYYY');
        elt.dateFin = this.dateReconduction;
        elt.id = 0;
        elt.clef = '0';
        elt.modelDebut = elt.dateDebut
        elt.modelFin = elt.dateFin
        const fct = this.saveModif(elt);
        prom.push(fct);
      });

      Promise.all(prom).then(data => {
        this.isReconduire = false;
        this.getListPrixNego();
      }).catch(error => {
        this.common.closeModal();
        this.error = error;
        this.common.openModal(this.modalService, this.msg);
      });
    }
  }

  /**
   * Tout remettre à gauche
   */
  revertReconduction() {
    // this.listPrixReconduire = [];
    this.listDerPrixNeg.push(...this.listPrixReconduire);
    this.listPrixReconduire = [];
  }

  /**
   * Supprimer row de la liste de droite
   */
  removeReconduction(row) {
    // this.listPrixReconduire = this.listPrixReconduire.filter(elt => elt !== row);    
    this.listPrixReconduire = this.listPrixReconduire.filter(item => item !== row);

    // Le remettre à gauche s'il n'y est pas déjà
    if (!this.listDerPrixNeg.includes(row)) {
      this.listDerPrixNeg.push(row);
    }
  }

  changeDateShow() {
    return this.listPrixReconduire.length ? this.getMinDate(this.listPrixReconduire)[0] : this.getMinDate(this.listDerPrixNeg)[0];
  }

  getMinDate(data) {
    return data.sort(function (a, b) {
      a = a.time;
      b = b.time;
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      }
      return 0;
    });
    //  data.reduce((min, p) => p.time > min ? p.time : min, data[0]);
  }

  valideVerImprimable() {
    const dateFin = moment().subtract(1, 'months');
    const famille = this.familleImprimable === '8' ? '\u0025' : this.familleImprimable;
    const param = {
      'servlet': 'DBRapportsgeneriques',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'TITRE': 'PrixNegoClient',
        'FORMAT': 'PDF',
        'NOM_FICHIER': 'PrixNegoClient',
        'DATE_FIN': moment(dateFin).startOf('month').format('YYYY-MM-DD'),
        'CLEF_CLIENT': '' + this.detail['id'],
        'FAMILLE': '' + famille,
        'CLEF_SITE': this.societe['prixNegoParSite'] ? ('' + this.common.user[2]) : '0',
        'IS_ANGULAR': {
          'typeParam': 'boolean',
          'valeur': true
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      if (this.common.verifySession(datas)) {
        if (datas.data && datas.data[0]) {
          this.common.openFile(datas.data[0]);
        } else {
          if (datas.message) {
            this.error = datas.message;
            this.common.openModal(this.modalService, this.msg);
          }
        }
      }
    });
  }

  extraireXls() {
    if (!this.isHisto) {
      this.familleXls = '8';
      this.common.openModal(this.modalService, this.xls);
    } else {
      this.detail['nomclass'] = 'Client';
      const param = {
        'servlet': 'DBGetListPrixNegociesHistoXLS',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'pathImpression': 'Recylog/tmp/',
        'data': {
          'CLEF_CLIENT': {
            'typeParam': 'int',
            'valeur': this.detail['id']
          },
          'CLEF_SITE': {
            'typeParam': 'int',
            'valeur': this.societe['prixNegoParSite'] ? this.common.user[2] : 0
          },
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        $('#empty').trigger('click');
        if (this.common.verifySession(datas)) {
          if (datas.data && datas.data[0]) {
            this.common.openFile(datas.data[0]);
          } else {
            if (datas.message) {
              this.error = datas.message;
              this.common.openModal(this.modalService, this.msg);
            }
          }
        }
      });
    }

  }

  valideXls() {
    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBGetListPrixNegocieXLS',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'FAMILLE': {
          'typeParam': 'int',
          'valeur': this.familleXls
        },
        'CLIENT': this.detail,
        'SITE': this.societe['prixNegoParSite'] ? ('' + this.common.user[2]) : '0',
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      if (this.common.verifySession(datas)) {
        if (datas.data && datas.data[0]) {
          this.common.openFile(datas.data[0]);
        } else {
          if (datas.message) {
            this.error = datas.message;
            this.common.openModal(this.modalService, this.msg);
          }
        }
      }
    });
  }

  changeDateDebut(event, row) {
    if (moment(event).isValid()) {
      row['dateDebut'] = moment(event).format('DD/MM/YYYY');
      // console.log(row['dateDebut']);
    } else {
      row['dateDebut'] = moment().format('DD/MM/YYYY');
      // console.log(row['dateDebut']);
    }

  }

  changeDateFin(event, row) {
    if (moment(event).isValid()) {
      row['dateFin'] = moment(event).format('DD/MM/YYYY');
    } else {
      row['dateFin'] = moment().format('DD/MM/YYYY');

    }
  }

  changeDateSel(event, row) {
    if (moment(event).isValid()) {
      this.dateFinSelected = moment(event).format('DD/MM/YYYY');
    } else {
      this.dateFinSelected = moment().format('DD/MM/YYYY');
    }
  }

  changeDate(event) {
    if (moment(event).isValid()) {
      this.dateReconduction = moment(event).format('DD/MM/YYYY');
      // console.log(this.dateReconduction);
    } else {
      this.dateReconduction = moment().format('DD/MM/YYYY');
      // console.log(this.dateReconduction);
    }
  }

  selectDate(event, id) {
    this.common.focusElement(id);
  }

  getCellClass({ row, column, value }): any {
    return {
      'nonImprime': moment().isSameOrAfter(moment(row.modelFin))
    };
  }

  getCellClassOther({ row, column, value }): any {
    return {
      'colGris': moment().isSameOrAfter(moment(row.modelFin))
    };
  }

  insertDevisFct() {
    if (this.selected && this.selected.length > 0) {
      this.isClick = true;
      const prix = this.selected[0];
      const param = {
        'servlet': 'DBGetArticle',
        'module': 'Recylog',
        'type': 'tableau',
        'compression': 'false',
        'forcerSerialisation': 'true',
        'data': ['DBGetArticle', (prix.article ? (prix.article.id || 0) : 0), this.detail['id'] || 0, '01/01/2000',
          '0', '0', '0', '0', '0', this.common.user[2]]
      };
      return this.common.post('', { param: param }).then(datas => {
        if (datas.data && datas.data.length) {
          prix.article = datas.data[0];
          prix.description = datas.data !== null ? datas.data[0].libelle : '';
          prix.txTVA = datas.data !== null ? datas.data[0].tva : '';
          prix.typeTarif = datas.data !== null ? datas.data[0].typeTarif : '';
          this.insertDevis.emit(prix);
        }
      });

    } else {
      this.error = 'Vous devez sélectionner un prix négocié dans la liste des prix de l\'onglet courant.';
      this.common.openModal(this.modalService, this.msg);
    }
  }

  onColumnSort(event) {
    this.common.prixNegocieTrie = event.sorts;
  }

  onColumnResize(event) {
    if (this.table && this.table._internalColumns) {
      this.table._internalColumns.forEach((elt, index) => {
        if (!this.isHisto && !this.depuisDevis) {
          if (index !== 0 && this.columns[index - 1]) {
            this.columns[index - 1].width = elt.width;
          }
        } else {
          if (this.columnsHisto[index]) {
            this.columnsHisto[index].width = elt.width;
          }
        }
      });
    }
  }

  recalculWidth() {
    this.updateAfficheScroll();
  }

  onScroll(offsetY: number, offsetX?: number) {
    if (this.listPrixNegocier && this.listPrixNegocier.length) {
      if (!this.isHisto) {
        this.offset = {
          offsetY: offsetY || 0,
          offsetX: offsetX || 0
        };
        if (this.isDepuisMenuEnHaut) {
          this.common.ficheClientPrixNegocies['offset'] = this.offset;
        }
      } else {
        this.offsetHisto = {
          offsetY: offsetY || 0,
          offsetX: offsetX || 0
        };
        if (this.isDepuisMenuEnHaut) {
          this.common.ficheClientPrixNegocies['offsetHisto'] = this.offsetHisto;
        }
      }
      console.log(this.offset, this.offsetHisto)
    }
  }

  onActivate(event) {
  }


  initChamp(param) {
    switch (param) {
      case 'zoneClible':
        if (this.selectedRow[param] && this.selectedRow[param].id) {
          this.selectedRow['chantier'] = this.listChantier[0];
        }
        break;

      case 'chantier':
        if (this.selectedRow[param] && this.selectedRow[param].id) {
          this.selectedRow['zoneClible'] = this.listeAgence[0];
        }
        break;


      default:
        break;
    }
  }



  addFiltreDynamic(type, value, title) {
    this.selectedFilter[type] = value;
    const index = this.dynamicFiltre.findIndex(elt => elt.type === type);
    if (index !== -1) {
      this.dynamicFiltre[index].value = value;
      this.dynamicFiltre[index].title = title;
    } else {
      this.dynamicFiltre.push({ type, value, title });
    }
    this.filterList();
  }



  filterList() {
    this.listPrixNegocier = this.listPrixNegocierOriginal.filter(el => {
      return this.dynamicFiltre.every(filtre => {
        const field = el[filtre.type];
        return filtre.value === 0 || field && field.id === filtre.value;
      });
    });

    this.listPrixNegocier = [...this.listPrixNegocier];
  }


  getNbrFiltres() {
    let total = 0;

    for (const key in this.selectedFilter) {
      if (key) {
        if (this.selectedFilter[key] && this.selectedFilter[key] !== -1) {
          total = total + 1;
        }
      }
    }

    return total;
  }

  public change(value: boolean): void {
    this.status.isopen = value;
  }


  getListFiltrePrixNego() {
    this.detail['nomclass'] = 'Client';
    this.loadingIndicator = true;
    this.listFiltreChantier = []
    this.listFiltreAgence = []
    const param = {
      'servlet': 'DBGetListFiltrePrixNego',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [
        ['DBGetListFiltrePrixNego'],
        {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        '' + this.common.user[2],
        {
          'typeParam': 'boolean',
          'valeur': false
        },
        {
          'typeParam': 'int',
          'valeur': 0
        }
      ]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.data && datas.data.length) {
        this.listFiltreChantier = this.sortFiltre(datas.data[0] || [], 'numChantier');
        this.listFiltreAgence = this.sortFiltre(datas.data[1] || [], 'libelleObjetEntite');
      }
    });
  }

  sortFiltre(items, key) {

    return items.sort((a, b) =>
      String(a[key] ?? '').localeCompare(String(b[key] ?? ''), 'fr', {
        sensitivity: 'base',   // ignore majuscules/accents
        numeric: true          // "Item 2" < "Item 10"
      })
    );

  }

  getListFiltrePrixNegoHisto() {
    this.detail['nomclass'] = 'Client';
    this.loadingIndicator = true;
    this.listFiltreChantier = []
    this.listFiltreAgence = []
    const param = {
      'servlet': 'DBGetListFiltrePrixNegoHisto',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.societe['prixNegoParSite'] ? this.common.user[2] : 0
        },
        'IS_AJOUT_DONNEES_CONTRAT': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'CLEF_CONTRAT_EXCLU': {
          'typeParam': 'int',
          'valeur': 0
        }
      }
    }

    return this.common.post('', { param: param }).then(datas => {
      if (datas.data && datas.data.length) {
        this.listFiltreChantier = this.sortFiltre(datas.data[0] || [], 'numChantier');
        this.listFiltreAgence = this.sortFiltre(datas.data[1] || [], 'libelleObjetEntite');
      }
    });
  }

  checkedAll(event) {
    this.listPrixNegocier.forEach(elt => {
      elt.isChecked = this.checkedall;
      this.checkedRow(elt);
    });
  }

  checkedRow(selected, event?) {
    if (selected.isChecked) {
      this.listChecked.push(selected);
    } else {
      this.listChecked.splice(this.listChecked.indexOf(selected), 1);
    }
  }

  historiserPrixSelected() {
    if (!this.listChecked.length) {
      this.error = "Il faut sélectionner au moins une ligne."
      this.common.openModal(this.modalService, this.msg);
      return false;
    } else {
      this.modelDateFinSel = this.common.parseDate(moment().format('DD/MM/YYYY'))
      this.dateFinSelected = moment().format('DD/MM/YYYY')
      this.common.openModal(this.modalService, this.choixDateFin)
    }
  }

  valideChoixDate() {
    this.listChecked = (this.listChecked || []).map(item => ({ ...item, nomclass: "PrixNegocies" }));
    const param = {
      'servlet': 'DBGestionPrixNego',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'DATE_FIN': {
          'typeParam': 'date',
          'valeur': this.dateFinSelected
        },
        'LISTE_PRIX_NEGO': this.listChecked,
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (!datas.message) {
        this.listChecked = [];
        this.dateFinSelected = "";
        this.common.closeModal();
        this.getListPrixNego();
      }
    }).catch((err) => {
      console.log('err')
    })
  }
}
